import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên",
    name: "username",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: INPUT,
    label: "Công ty",
    name: "company",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: INPUT,
    label: "Vị trí",
    name: "jobTitle",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: INPUT,
    label: "Địa điểm",
    name: "location",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: DATE,
    label: "Ngày bắt đầu",
    name: "startDate",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: DATE,
    label: "Ngày kết thúc",
    name: "endDate",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    type: INPUT,
    label: "Mô tả",
    name: "description",
    rules: [{required: true, message: "Chưa nhập mô tả"}],
  },
];
export {dataFields};
